import React from 'react';
import {Form, Button, Checkbox, Table, Popup, Icon, Loader, Grid, Header, Segment} from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';
import SearchTableData from "../../util/SearchTableData";
import PaginationFront from "../../util/PaginationFront";
import axios from "axios";
import {
    fetchAllAcademicYears,
    fetchStudyCycle,
} from "../../Lookups/util";
import ReactExport from "react-data-export";
import ReportExcelFile from './ReportExcelFile';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';
import {
    additionalFilterSectionStyle,
    checkboxFieldStyle,
    filterFieldGridStyle,
    requiredFilterSectionStyle
} from './reportUiHelpers';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;

const PROMOTION_ACADEMIC_YEAR_START_YEAR = 2025;
const getAcademicYearStartYear = (academicYear) =>
    academicYear.startYear || parseInt((academicYear.name || '').split('/')[0], 10) || 0;
const promotionYearLabelStyle = {
    display: 'block',
    fontWeight: 700,
    marginBottom: '0.28571429rem',
};

export default class LockedGraduatedStudents extends React.Component {
    constructor(props) {
        super(props);
        const activeRole = localStorage.getItem('activeRole') || '';
        const studentService = activeRole.substr(0, 10) === 'Studentska';
        const vicedean = activeRole.substr(0, 19) === 'Prodekan za nastavu';
        const adminOrAida = activeRole.substr(0, 13) === 'Administrator' || activeRole.substr(0, 4) === 'AIDA';
        const countOnly = !!props.countOnly;

        this.state = {
            endDateErr: false,
            startDateErr: false,

            startDate: null,
            endDate: null,
            promotionAcademicYearId: null,
            academicYears: [],

            organizationalUnitId: null,

            student: null,
            studyCycles:[],
            studyCycle: null,

            studyProgramBasicId: null,
            studyProgramBasics: [],
            studyProgramBasicsAll: [],
            locked: false,
            diplomaPrinted: false,

            loaded: null,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            countOnly,
            adminOrAida,
            unsa: countOnly || (!adminOrAida && !studentService && !vicedean),

            results: [],
            students:[],
            excelData:[],


        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.checkDate = this.checkDate.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
        this.filter = this.filter.bind(this);
    }

    componentDidMount() {
        let obj = {};
        axios.post((this.state.unsa || this.state.adminOrAida) ? 'study-programs/basic/all' : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.unsa ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

        axios.all([ fetchStudyCycle(), fetchAllAcademicYears()])
            .then(axios.spread(( studyCycleRes, academicYearsRes) => {
                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));
                const academicYears = academicYearsRes.data
                    .slice()
                    .filter(year => getAcademicYearStartYear(year) >= PROMOTION_ACADEMIC_YEAR_START_YEAR)
                    .sort((a, b) => (b.id || 0) - (a.id || 0))
                    .map(el => ({
                        ...el,
                        key: el.id,
                        value: el.id,
                        text: el.name,
                    }));

                this.setState({
                    studyCycles,
                    academicYears
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch studyCycles or academic years.');
            });
    }

        getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.students;
    }

    getResults(results) {
        if(results.length === 0){
            this.setState({
                excelData: this.state.unsa ?  this.state.students.map(el => ([
                        { value: el.organizationalUnitName },
                        { value: el.numberOfStudents},
                    ]))
                    : this.state.students.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.indexNumber},
                        { value: el.documentNumber},
                        { value: el.dateOfGraduation ? moment(el.dateOfGraduation).format('D. M. YYYY.') : ''},
                        { value: el.department},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.promotionAcademicYearName || ''},
                        { value: el.title},
                        { value: el.locked ? 'DA' : 'NE'},
                        { value: el.diplomaPrinted ? 'DA' : 'NE'},
                    ]))});
        }
       else{
            this.setState({ results,
                excelData: this.state.unsa ?  results.map(el => ([
                        { value: el.organizationalUnitName },
                        { value: el.numberOfStudents},
                    ]))
                    : results.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.indexNumber},
                        { value: el.documentNumber},
                        { value: el.dateOfGraduation ? moment(el.dateOfGraduation).format('D. M. YYYY.') : ''},
                        { value: el.department},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.promotionAcademicYearName || ''},
                        { value: el.title},
                        { value: el.locked ? 'DA' : 'NE'},
                        { value: el.diplomaPrinted ? 'DA' : 'NE'},
                    ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    getFilteredStudyProgramBasics(studyCycle, organizationalUnitId) {
        return this.state.studyProgramBasicsAll.filter(el => {
            const matchesStudyCycle = studyCycle
                ? el.studyProgramBasic.studyCycles.some(cycle => cycle.id === studyCycle)
                : true;
            const matchesOrganizationalUnit = organizationalUnitId
                ? el.organizationalUnit && el.organizationalUnit.id === organizationalUnitId
                : true;

            return matchesStudyCycle && matchesOrganizationalUnit;
        });
    }

    checkDate() {
        if (this.state.startDate && !this.state.endDate) {
            toast('Morate unijeti i datum kraja!');
            this.setState({ endDateErr: true });
            return false;
        } else if (!this.state.startDate && this.state.endDate) {
            toast('Morate unijeti i datum početka!');
            this.setState({ startDateErr: true });
            return false;
        } else {
            this.setState({ startDateErr: false, endDateErr: false });
            return true;
        }
    }

    handleInputChange(event, { name, value }) {
        if (name === 'studyCycle' || name === 'organizationalUnitId') {
            const studyCycle = name === 'studyCycle' ? value : this.state.studyCycle;
            const organizationalUnitId = name === 'organizationalUnitId' ? value : this.state.organizationalUnitId;
            this.setState({
                studyProgramBasics: this.getFilteredStudyProgramBasics(studyCycle, organizationalUnitId),
                studyProgramBasicId: null,
            });
        }

        if (name === 'promotionAcademicYearId' && value) {
            this.setState({ startDate: null, endDate: null, startDateErr: false, endDateErr: false });
        }

        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        if (name === 'endDate') {
            if (this.state.startDate && date < this.state.startDate) {
                toast('Datum kraja mora biti poslije datuma početka!');
            } else  this.setState({
                [name]: date,
                promotionAcademicYearId: date ? null : this.state.promotionAcademicYearId
            });
        }

        if (name === 'startDate') {
            if (this.state.endDate && date > this.state.endDate) {
                toast('Datum početka mora biti prije datuma kraja!');
            } else
                this.setState({
                [name]: date,
                promotionAcademicYearId: date ? null : this.state.promotionAcademicYearId
            });
        }
    }

    filter(){
        if (!this.checkDate()) {
            return;
        }

        if (!this.state.countOnly && this.state.adminOrAida && !this.state.organizationalUnitId) {
            toast('Morate odabrati organizacionu jedinicu!');
            return;
        }

        this.setState({ loaded: false, results: [], activePage: 1 });
        let obj = { graduated: true };
        if (this.state.studyCycle) obj = { ...obj, studyCycleId: this.state.studyCycle };
        if (this.state.locked) obj = { ...obj, locked: this.state.locked };
        if (this.state.diplomaPrinted) obj = { ...obj, diplomaPrinted: this.state.diplomaPrinted };
        if (this.state.promotionAcademicYearId) obj = { ...obj, promotionAcademicYearId: this.state.promotionAcademicYearId };
        if (this.state.startDate) obj = { ...obj, startDate: this.state.startDate };
        if (this.state.endDate) obj = { ...obj, endDate: this.state.endDate };
        if (this.state.studyProgramBasicId) obj = { ...obj, studyProgramBasicId: this.state.studyProgramBasicId };

        if(this.state.unsa){
            axios.post('reports/graduated-students-count/', { ...obj })
                .then(res => {

                    this.setState({   students: res.data, loaded: true,
                        excelData: res.data.map(el => ([
                            { value: el.organizationalUnitName },
                            { value: el.numberOfStudents},
                        ]))
                    })})
                .catch(err => {
                    console.log('Failed to fetch students');
                });
        }
        else{
        axios.post(this.state.adminOrAida ? `/graduation-documents/${this.state.organizationalUnitId}` : '/graduation-documents/', { ...obj })
            .then(res => {
                this.setState({
                    students: res.data.map(el => ({
                        ...el,
                        date: moment(el.dateOfGraduation).format('D. M. YYYY.'),
                        department:el.departmentsSPOU[0].organizationalUnitName,
                        diplomaPrintedDisplay: el.diplomaPrinted ? 'DA' : 'NE',
                        lockedDisplay: el.locked ? 'DA' : 'NE',
                        statusDisplay: [
                            el.locked ? 'Zaključano' : null,
                            el.diplomaPrinted ? 'Odštampano' : null
                        ].filter(Boolean).join(' ')
                    })), loaded: true,
                    excelData: res.data.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.indexNumber},
                        { value: el.documentNumber},
                        { value: el.dateOfGraduation ? moment(el.dateOfGraduation).format('D. M. YYYY.') : ''},
                        { value: el.departmentsSPOU[0].organizationalUnitName},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.promotionAcademicYearName || ''},
                        { value: el.title},
                        { value: el.locked ? 'DA' : 'NE'},
                        { value: el.diplomaPrinted ? 'DA' : 'NE'},
                    ]))});
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch graduation documents');
            });}
    }

    renderStatusIcons(row) {
        if (!row.locked && !row.diplomaPrinted) {
            return null;
        }

        return (
            <span style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                {row.locked && (
                    <Popup
                        content="Zaključano"
                        position="top center"
                        trigger={<Icon name="lock" color="blue" />}
                    />
                )}
                {row.diplomaPrinted && (
                    <Popup
                        content="Odštampano"
                        position="top center"
                        trigger={<Icon name="print" color="teal" />}
                    />
                )}
            </span>
        );
    }

    render() {

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Ime oca', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Broj diplome', width: { wpx: 150 } },
                    { title: 'Datum diplimiranja', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 300 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'NPP', width: { wpx: 150 } },
                    { title: 'Godina promocije', width: { wpx: 150 } },
                    { title: 'Zvanje', width: { wpx: 400 } },
                    { title: 'Zaključan', width: { wpx: 100 } },
                    { title: 'Odštampana', width: { wpx: 120 } }
                ],
                data: this.state.excelData,
            }
        ];

        const multiDataSet1 = [
            {
                columns: [
                    { title: 'Organizaciona jedinica', width: { wpx: 150 } },
                    { title: 'Broj studenata', width: { wpx: 150 } },
                ],
                data: this.state.excelData,
            }
        ];

        return (
            <div>
                <Form>
                    {!this.state.countOnly && this.state.adminOrAida && (
                        <Segment style={requiredFilterSectionStyle}>
                            <Header as="h4" color="blue">Obavezni parametri</Header>
                            <Form.Group widths="equal" style={filterFieldGridStyle}>
                                <Form.Field>
                                    <Form.Dropdown
                                        label="Organizaciona jedinica"
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={this.state.organizationalUnitId}
                                        onChange={this.handleInputChange}
                                        name="organizationalUnitId"
                                        options={this.props.organizationalUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                            </Form.Group>
                        </Segment>
                    )}

                    <Segment style={additionalFilterSectionStyle}>
                        <Header as="h4" color="blue">Dodatni filteri</Header>
                        <Form.Group widths="equal" style={filterFieldGridStyle}>
                            <Form.Field>
                                <label style={promotionYearLabelStyle}>Godina promocije <Popup
                                    trigger={<Icon name="info circle" color="blue" style={{ marginLeft: '4px' }} />}
                                    content="Podatak o godini promocije se u bazu podataka unosi tek od 2025/2026 godine, zato nije moguće odabrati ranije godine."
                                    on="hover"
                                    hideOnScroll
                                    position="top center"
                                /></label>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite godinu promocije"
                                    value={this.state.promotionAcademicYearId}
                                    onChange={this.handleInputChange}
                                    name="promotionAcademicYearId"
                                    options={this.state.academicYears}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field error={this.state.startDateErr}>
                                <label>Datum početka</label>
                                <DateTimePicker
                                    format="D .M. YYYY."
                                    defaultValue={null}
                                    time={false}
                                    onChange={this.handleDateChange.bind(null, 'startDate')}
                                    value={this.state.startDate}
                                />
                            </Form.Field>
                            <Form.Field error={this.state.endDateErr}>
                                <label>Datum kraja</label>
                                <DateTimePicker
                                    format="D. M. YYYY."
                                    defaultValue={null}
                                    time={false}
                                    onChange={this.handleDateChange.bind(null, 'endDate')}
                                    value={this.state.endDate}
                                />
                            </Form.Field>
                        </Form.Group>

                        <Form.Group widths="equal" style={filterFieldGridStyle}>
                            <Form.Field>
                                <Form.Dropdown
                                    label="Ciklus studija"
                                    clearable
                                    placeholder="Odaberite ciklus studija"
                                    value={this.state.studyCycle}
                                    onChange={this.handleInputChange}
                                    name="studyCycle"
                                    options={this.state.studyCycles}
                                    search
                                    fluid
                                    selection

                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    label="Studijski program"
                                    clearable
                                    placeholder="Odaberite studijski program"
                                    options={this.state.studyProgramBasics}
                                    onChange={this.handleInputChange}
                                    name="studyProgramBasicId"
                                    value={this.state.studyProgramBasicId}
                                    search
                                    fluid
                                    selection
                                />
                            </Form.Field>
                            <Form.Field />
                        </Form.Group>

                        <Form.Group>
                            <Form.Field style={checkboxFieldStyle}>
                                <Checkbox
                                    type="checkbox"
                                    name="locked"
                                    id="locked"
                                    onChange={(e, { checked }) => this.setState({ locked: checked})}
                                    checked={this.state.locked}
                                    label="Zaključani studenti"
                                />
                            </Form.Field>
                            <Form.Field style={checkboxFieldStyle}>
                                <Checkbox
                                    type="checkbox"
                                    name="diplomaPrinted"
                                    id="diplomaPrinted"
                                    onChange={(e, { checked }) => this.setState({ diplomaPrinted: checked})}
                                    checked={this.state.diplomaPrinted}
                                    label="Odštampane diplome"
                                />
                            </Form.Field>
                        </Form.Group>
                    </Segment>

                    <br /><br />

                    <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button color="blue" floated="right" onClick={this.filter}>Prikaži izvještaj
                    </Button>

                </Form>

                <br /><br /><br />

                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :

                    this.state.loaded &&
                    <div>

                        {this.state.students.length ?
                            <Table celled selectable compact>
                                <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={this.state.unsa ? 2 : 18} >
                                <Grid column={2} stackable>
                                    <Grid.Column width={14}>
                                        <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['lastName', 'firstName', 'fatherName', 'indexNumber', 'documentNumber', 'dateOfGraduation', 'department', 'studyProgramBasicName', 'studyProgramName', 'promotionAcademicYearName', 'title', 'statusDisplay' ]} />
                                    </Grid.Column>
                                    <Grid.Column width={2} textAlign="center">
                                        <ExcelFile filename="Diplomirani studenti" element={<Popup
                                            trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                <Button.Content visible>
                                                    Excel
                                                </Button.Content>
                                            </Button>}
                                            content="Preuzmi spisak u Excel-u"
                                            hideOnScroll
                                            position="top center"
                                        />}>
                                            <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                        </ExcelFile>

                                    </Grid.Column>
                                </Grid>
                            </Table.HeaderCell>
                        </Table.Row>
                    {this.state.unsa ? <Table.Row>
                            <Table.HeaderCell >Organizaciona jedinica</Table.HeaderCell>
                            <Table.HeaderCell >Broj studenata</Table.HeaderCell>
                        </Table.Row>
                        : <Table.Row>
                            <Table.HeaderCell width={1}>
                                R. br.
                            </Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>Prezime (ime oca) i ime</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Odsjek</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} >Studijski program</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Broj diplome</Table.HeaderCell>
                            <Table.HeaderCell width={4}>Index</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2} >Datum diplomiranja</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>Godina promocije</Table.HeaderCell>
                            <Table.HeaderCell colSpan={3}>Zvanje</Table.HeaderCell>
                        </Table.Row>}
                    </Table.Header>
                            {this.state.unsa ?
                                <Table.Body> {currentPosts.map((el, index) =>
                                    (<Table.Row key={index}>
                                            <Table.Cell verticalAlign="middle">
                                                {el.organizationalUnitName}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle">
                                                {el.numberOfStudents}
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                                : <Table.Body collapsing> {currentPosts.map((row, index) => (
                                     <Table.Row key={index}>
                                        <Table.Cell verticalAlign="middle" collapsing>
                                            {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.

                                        </Table.Cell>
                                        <Table.Cell colSpan={3}>
                                            {row.lastName} ({row.fatherName}) {row.firstName}
                                            <span style={{ float: 'right' }}>
                                                {this.renderStatusIcons(row)}
                                            </span>
                                        </Table.Cell>
                                        <Table.Cell colSpan={2}>{row.departmentsSPOU.map(e => <div>{e.organizationalUnitName} <br /></div>)}</Table.Cell>
                                        <Table.Cell colSpan={2} ><strong>{row.studyProgramBasicName}</strong> | {row.studyProgramName}</Table.Cell>
                                        <Table.Cell colSpan={2}>{row.documentNumber}</Table.Cell>
                                        <Table.Cell width={4}>{row.indexNumber}</Table.Cell>
                                        <Table.Cell colSpan={2}>{row.dateOfGraduation === null ? null : moment(row.dateOfGraduation).format('D. M. YYYY.')}</Table.Cell>
                                        <Table.Cell colSpan={2}>{row.promotionAcademicYearName || '-'}</Table.Cell>
                                        <Table.Cell colSpan={3}>{row.title}</Table.Cell>
                                    </Table.Row>
                                  ))}
                                </Table.Body>}
                </Table> : 'Nema podataka.'}

                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
             </div>}
                <ToastContainer hideProgressBar />
                    </div>
                    );
                }
                }



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/LockedGraduatedStudents.js